.modalOverlay {
  background-color: rgba(239, 243, 244, 0.8);
  bottom: 0;
  display: inline-block;
  height: 100vh;
  left: 0;
  overflow-y: auto;
  position: absolute;
  right: 0;
  top: 0;
  width: 100%;
  z-index: 11;
}

.modalWrapper {
  align-items: center;
  display: flex;
  height: 100%;
}

.modal {
  background: white;
  border-radius: 20px;
  box-shadow: 0px 0px 15px 3px rgba(0, 0, 0, 0.07);
  margin: 50px auto;
  max-width: 680px;
  position: relative;
  width: 100%;

  .modalBody {
    padding: 32px 16px;
  }

  .closeBtn {
    position: absolute;
    right: 13px;
    top: 10px;
    width: fit-content;
  }

  .closeBtn button:hover {
    background-color: white;
  }
}

@media screen and (max-width: 500px) {
  .modalOverlay .modal .modalBody {
    padding: 48px 0 24px 0;
  }
}

@media screen and (max-width: 720px) {
  .modalOverlay .modal {
    width: 90%;
  }
}

@media screen and (max-height: 540px) {
  .modalOverlay {
    padding: 50px 0;
  }
}

@media screen and (max-height: 440px) {
  .modalOverlay {
    padding: 100px 0;
  }
}

@media screen and (max-height: 340px) {
  .modalOverlay {
    padding: 120px 0;
  }
}
